export const BRANDING_TYPE = {
  light: 'BRANDING_TYPE_LIGHT',
  full: 'BRANDING_TYPE_FULL',
};
